module.exports = __webpack_public_path__ + "static/media/7ae.257c626b.jpg";